import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=3ff5a36a"
import script from "./TableBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableBase.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports